import { useState } from 'react';
import Select from 'react-select';
import { Button } from '../../components/button';
import { Dialog, DialogTitle, DialogBody, DialogActions } from '../../components/dialog';
import { Field, Label, Fieldset } from '../../components/fieldset';
import { Input } from '../../components/input';
import { useCodeDefinitionsAsOptions } from '../../hooks/useCodeDefinitions';
import { reactSelectReset } from '../../utils/utils';

interface AddNewFacilityDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { name: string; type: string }) => void;
}

export function AddNewFacilityDialog({ open, onClose, onSubmit }: AddNewFacilityDialogProps) {
  const [name, setName] = useState('');
  const [type, setType] = useState<string>('');

  const { data: selectOptions = [] } = useCodeDefinitionsAsOptions('FacilityTypes');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ name, type });
    setName('');
    setType('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Add New Facility</DialogTitle>
        <DialogBody>
          <Fieldset>
            <div className="tw:space-y-6">
              <Field>
                <Label htmlFor="facility-name">
                  Facility Name
                  <span className="tw:text-stoplight-danger">*</span>
                </Label>
                <Input
                  id="facility-name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="tw:w-full"
                />
              </Field>
              <Field>
                <Label htmlFor="facility-type">
                  Facility Type
                  <span className="tw:text-stoplight-danger">*</span>
                </Label>
                <Select
                  options={selectOptions}
                  value={selectOptions.find((option) => option.value === type) || null}
                  onChange={(option) => setType(option?.value ?? '')}
                  placeholder="Select Facility Type"
                  className="tw:w-full"
                  required
                  styles={reactSelectReset}
                />
              </Field>
            </div>
          </Fieldset>
        </DialogBody>
        <DialogActions>
          <Button type="button" plain onClick={onClose}>
            Cancel
          </Button>
          <Button color="brandgreen0" type="submit">
            Add Facility
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
